import { useRoutes, RouteObject } from 'react-router-dom';
import ErrorBoundary from './components/errorBoundary/ErrorBoundary';
import React, { Suspense } from 'react';
import { Product } from './domain/product/product.model';
import { routes } from './routes';
import SizeGuide from './pages/sizeGuide';
import { storeRoutes } from './pages/store/StoreRoutes';
import { userRoutes } from './pages/user/UserRoutes';
import { checkoutRoutes } from './pages/checkout/CheckoutRoutes';
import HomePage from './pages/home';
import InvalidTokenPage from './pages/invalidToken';
import { blogRoutes } from './pages/blog/BlogRoutes';
import { cartRoutes } from './pages/cart/CartRoutes';
import { infoRoutes } from './pages/infoPages/InfoRoutes';

interface Props {
  mosaicData: Array<Product>;
}

const AppRoutes: React.FC<Props> = ({ mosaicData }) => {
  const routesConfig: RouteObject[] = [
    {
      path: routes.BASE,
      element: <HomePage dataToMosaic={mosaicData?.length > 0 ? mosaicData : []} />,
    },
    {
      path: routes.SIZE_GUIDES,
      element: <SizeGuide />,
    },
    {
      path: routes.INVALID_TOKEN,
      element: <InvalidTokenPage />,
    },
    ...blogRoutes,
    ...cartRoutes,
    ...checkoutRoutes,
    ...infoRoutes,
    ...storeRoutes,
    ...userRoutes,
    // {
    //   path: '*',
    //   element: <NotFound />, // Evita los warnings
    // },
  ];

  const routing = useRoutes(routesConfig);

  return (
    <ErrorBoundary>
      <Suspense fallback={<div>Loading...</div>}>{routing}</Suspense>
    </ErrorBoundary>
  );
};

export default AppRoutes;

// const AppRoutes: React.FC<Props> = ({ mosaicData }) => (
//     <ErrorBoundary>
//       <Routes>
//         <Route path={routes.BASE} element={<HomePage dataToMosaic={mosaicData?.length > 0 ? mosaicData : []} />} />
//         <Route path={routes.SIZE_GUIDES} element={<SizeGuide />} />
//         <Route path={routes.INVALID_TOKEN} element={<InvalidTokenPage />} />
//       </Routes>
//       <BlogRoutes />
//       <CartRoutes />
//       <CheckoutRoutes />
//       <InfoRoutes />
//       <StoreRoutes />
//       <UserRoutes />
//     </ErrorBoundary>
// );

// export default AppRoutes;
